import React from "react";
import { FormFindPartDesktop } from "./form.desktop";
import { FormFindPartMobile } from "./form.mobile";
import { LayoutStyleTypes, LayoutTypes, useLayoutType } from "@/util-react/layout";

const getPageComponent = (layoutStyleType: string) => {
  switch (layoutStyleType) {
    case LayoutStyleTypes.TYPE_XXS:
    case LayoutStyleTypes.TYPE_XS:
    case LayoutStyleTypes.TYPE_SM:
    case LayoutStyleTypes.TYPE_MD:
    case LayoutStyleTypes.TYPE_LG:
    case LayoutStyleTypes.TYPE_XL:
      return FormFindPartMobile;
    case LayoutStyleTypes.TYPE_XXL:
      return FormFindPartDesktop;
  }
};

export const FormFindPart: React.FC = () => {
  const { layoutStyleType } = useLayoutType();
  const PageComponent = getPageComponent(layoutStyleType);

  return <PageComponent />;
};
